import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getName } from "../ModelMixins/CatalogMemberMixin";
import { isTerriaFeatureData } from "../Models/Feature/FeatureData";
/** Adds timeseries chart to feature info context (on terria.timeSeries property).
 * This enables timeseries chart to be used in featureInfoTemplate like so:
 * - default chart = `{{terria.timeSeries.chart}}`
 * - customised chart:
 * ```
 *   <h4>{{terria.timeSeries.title}}</h4>
 *   <chart x-column="{{terria.timeSeries.xName}}"
 *       y-column="{{terria.timeSeries.yName}}"
 *       id="{{terria.timeSeries.id}}"
 *       column-units="{{terria.timeSeries.units}}">
 *           {{terria.timeSeries.data}}
 *   </chart>
 * ```
 */
export const tableFeatureInfoContext = catalogItem => feature => {
  var _feature$data$rowIds, _style$colorColumn, _style$colorColumn2, _style$timeColumn, _style$colorColumn3;
  if (!catalogItem.isSampled) return {};
  const style = catalogItem.activeTableStyle;

  // Corresponding row IDs for the selected feature are stored in TerriaFeatureData
  // See createLongitudeLatitudeFeaturePerId, createLongitudeLatitudeFeaturePerRow and createRegionMappedImageryProvider
  const rowIds = isTerriaFeatureData(feature.data) ? (_feature$data$rowIds = feature.data.rowIds) !== null && _feature$data$rowIds !== void 0 ? _feature$data$rowIds : [] : [];
  if (!style.timeColumn || !style.colorColumn || rowIds.length < 2) return {};
  const chartColumns = [style.timeColumn, style.colorColumn];
  const csvData = [chartColumns.map(col => col.title).join(","), ...rowIds.map(i => chartColumns.map(col => col.valueFunctionForType(i)).join(","))].join("\n").replace(/\\n/g, "\\n");
  const title = (_style$colorColumn = style.colorColumn) === null || _style$colorColumn === void 0 ? void 0 : _style$colorColumn.title;
  const featureId = feature.id.replace(/"/g, "");
  const timeSeriesContext = {
    title: (_style$colorColumn2 = style.colorColumn) === null || _style$colorColumn2 === void 0 ? void 0 : _style$colorColumn2.title,
    xName: (_style$timeColumn = style.timeColumn) === null || _style$timeColumn === void 0 ? void 0 : _style$timeColumn.title,
    yName: (_style$colorColumn3 = style.colorColumn) === null || _style$colorColumn3 === void 0 ? void 0 : _style$colorColumn3.title,
    units: chartColumns.map(column => column.units || ""),
    id: featureId,
    data: csvData,
    chart: "<chart ".concat('identifier="' + featureId + '" ', " ").concat(title ? "title=\"".concat(title, "\"") : "", ">").concat(csvData, "</chart>")
  };
  return {
    terria: {
      timeSeries: timeSeriesContext
    }
  };
};

/** Add `TimeSeriesFeatureInfoContext` to features with CSV string data (on `data` property) */
export const csvFeatureInfoContext = catalogItem => feature => {
  // Check that feature data has return CSV as string
  if (typeof feature.data === "string") {
    const featureId = feature.id.replace(/"/g, "");
    // Remove comment lines in CSV (start with # and don't have any commas)
    const csvData = feature.data.split("\n").filter(l => !(l.startsWith("#") && !l.includes(","))).join("\n");
    const title = getName(catalogItem);
    return {
      terria: {
        timeSeries: {
          title,
          id: featureId,
          data: csvData,
          chart: "<chart ".concat('identifier="' + featureId + '" ', " ").concat(title ? "title=\"".concat(title, "\"") : "", ">").concat(csvData, "</chart>")
        }
      }
    };
  }
  return {};
};